export const COMPACT_EMOJI_GROUPS = [
  { label: 'Faces', emojis: [
    ['😀', 'Grinning face'], ['😊', 'Smiling face'], ['😄', 'Happy face'], ['😁', 'Beaming face'],
    ['😂', 'Tears of joy'], ['🥰', 'Smiling with hearts'], ['😍', 'Heart eyes'], ['😎', 'Sunglasses'],
    ['🤔', 'Thinking face'], ['😅', 'Relieved smile'], ['🥳', 'Party face'], ['😌', 'Relieved face'],
  ] },
  { label: 'Gestures', emojis: [
    ['👍', 'Thumbs up'], ['👎', 'Thumbs down'], ['👏', 'Clapping'], ['🙌', 'Raised hands'],
    ['🤝', 'Handshake'], ['🙏', 'Thank you'], ['👋', 'Wave'], ['💪', 'Strong'],
    ['👌', 'Okay'], ['✌️', 'Peace'], ['🤞', 'Fingers crossed'], ['🫶', 'Heart hands'],
  ] },
  { label: 'Hearts & Celebrations', emojis: [
    ['❤️', 'Heart'], ['🧡', 'Orange heart'], ['💛', 'Yellow heart'], ['💚', 'Green heart'],
    ['💙', 'Blue heart'], ['💜', 'Purple heart'], ['🩷', 'Pink heart'], ['🎉', 'Celebration'],
    ['🎊', 'Confetti'], ['🎈', 'Balloon'], ['🎂', 'Birthday cake'], ['🎁', 'Gift'],
  ] },
  { label: 'Money', emojis: [
    ['💰', 'Money bag'], ['💵', 'Dollar bills'], ['💳', 'Credit card'], ['🏦', 'Bank'],
    ['🪙', 'Coin'], ['💸', 'Spending'], ['🐷', 'Piggy bank'], ['📈', 'Growing chart'],
    ['📉', 'Declining chart'], ['📊', 'Chart'], ['🧾', 'Receipt'], ['⚖️', 'Balance'],
  ] },
  { label: 'Home & Life', emojis: [
    ['🏡', 'Home'], ['🏠', 'House'], ['🔑', 'Key'], ['👨‍👩‍👧‍👦', 'Family'],
    ['👶', 'Baby'], ['💍', 'Wedding ring'], ['🎓', 'Graduation'], ['📚', 'Books'],
    ['💼', 'Work'], ['🏥', 'Hospital'], ['🛡️', 'Protection'], ['🏖️', 'Retirement beach'],
  ] },
  { label: 'Plans & Milestones', emojis: [
    ['🎯', 'Target'], ['✅', 'Check mark'], ['⭐', 'Star'], ['💡', 'Light bulb'],
    ['📌', 'Pin'], ['📅', 'Calendar'], ['📝', 'Notes'], ['📋', 'Checklist'],
    ['⏰', 'Alarm clock'], ['🔔', 'Reminder bell'], ['🚀', 'Rocket'], ['🏆', 'Trophy'],
  ] },
  { label: 'Travel & Nature', emojis: [
    ['✈️', 'Airplane'], ['🚗', 'Car'], ['🚲', 'Bicycle'], ['🚆', 'Train'],
    ['🌎', 'Globe'], ['🧳', 'Suitcase'], ['⛵', 'Sailboat'], ['🏔️', 'Mountain'],
    ['☀️', 'Sun'], ['🌈', 'Rainbow'], ['🌱', 'Seedling'], ['🌳', 'Tree'],
  ] },
  { label: 'Food & Fun', emojis: [
    ['☕', 'Coffee'], ['🍕', 'Pizza'], ['🍎', 'Apple'], ['🥑', 'Avocado'],
    ['🍽️', 'Dining'], ['🥂', 'Cheers'], ['🐶', 'Dog'], ['🐱', 'Cat'],
    ['🎨', 'Art'], ['🎵', 'Music'], ['⚽', 'Soccer'], ['🏃', 'Running'],
  ] },
  { label: 'Symbols', emojis: [
    ['✨', 'Sparkles'], ['🔥', 'Fire'], ['💯', 'Hundred points'], ['❗', 'Exclamation mark'],
    ['❓', 'Question mark'], ['⚠️', 'Warning'], ['🔒', 'Lock'], ['🔗', 'Link'],
    ['➡️', 'Right arrow'], ['⬆️', 'Up arrow'], ['⬇️', 'Down arrow'], ['🔄', 'Refresh'],
  ] },
];
